export const quizSeoDict = {
  en: {
    title:
      'Where to Get Citizenship or Residency in !year: Which Program Suits You Best?',
    description:
      'Answer 5 questions to find out which passport or residence permit suits you best—and how to obtain it. ➤ Citizenship by investment, Golden Visas, Digital Nomad Visas, and residency for financially independent individuals.',
  },
  ru: {
    title: 'Где получить инвестиционное гражданство или ВНЖ?',
    description:
      'Ответьте на 5 вопросов и узнайте, какой паспорт или вид на жительство подойдет именно вам — и как его получить. ➤ Инвестиционное гражданство и ВНЖ, а также варианты для цифровых кочевников, пенсионеров и финансово независимых лиц.',
  },
};

export const quizFromSelectDetails = {
  en: {
    title:
      'Compare 3 documents and choose the one that suits you best right now:',
    none: null,
    residencePermit: {
      title: 'Residence permit',
      description: [
        'Valid for 1—10 years',
        'Visa-free Schengen Area',
        'Citizenship after 5—10 years',
      ],
    },
    permanentResidence: {
      title: 'Permanent residency',
      description: [
        'Lifelong status',
        'Visa-free Schengen Area',
        'No voting rights',
      ],
    },
    citizenship: {
      title: 'Citizenship',
      description: [
        'Lifelong status',
        'Visa-free travels around the world',
        'Social benefits and guarantees',
        'Voting rights',
      ],
    },
  },
  ru: {
    title: 'Сравните 3 документа и выберите подходящий вам сейчас:',
    none: null,
    residencePermit: {
      title: 'Временный вид на жительство (ВНЖ)',
      description: [
        'Статус на 1—10 лет',
        'Путешествия в страны Шенгена без виз',
        'ПМЖ и гражданство через 5—10 лет',
      ],
    },
    permanentResidence: {
      title: 'Постоянный вид на жительство (ПМЖ)',
      description: [
        'Статус на всю жизнь',
        'Путешествия в страны Шенгена без виз',
        'Нельзя участвовать в выборах',
      ],
    },
    citizenship: {
      title: 'Гражданство',
      description: [
        'Статус на всю жизнь',
        'Путешествия без виз по миру',
        'Социальные льготы и гарантии',
        'Возможность участвовать в выборах',
      ],
    },
  },
};

export const quizFirstScreenDetails = {
  en: {
    title: 'Which passport or residency can help achieve your goals?',
    description:
      'Answer 5 questions and find out which document will help you achieve your goals at the minimum time and cost',
    buttonText: 'Find the one',
  },
  ru: {
    title: 'Какой паспорт или ВНЖ решит именно ваши задачи?',
    description:
      'Ответьте на 5 вопросов и узнайте, какой документ приведет к вашим целям с минимумом времени и денег',
    buttonText: 'Начать',
  },
};

export const quizCountrySelectScreenDetails = {
  en: {
    title: 'Please specify your current citizenship',
  },
  ru: {
    title: 'Укажите свое текущее гражданство',
  },
};

export const quizCommonDict = {
  en: {
    submitButtonText: 'Get comparison by email',
    downloadGuideButton: 'Download comparison',
    compareVariants: 'Compare your options',
    downloadGuide: 'Download comparison',
    compareVariantsDesc:
      'Evaluate the costs, timelines, pros, and cons to make an informed decision.',
  },
  ru: {
    submitButtonText: 'Получить на почту',
    downloadGuideButton: 'Скачать сравнение стран',
    compareVariants: 'Сравните варианты',
    downloadGuide: 'Скачать сравнение',
    compareVariantsDesc:
      'Оцените расходы, сроки, плюсы и минусы, чтобы принять взвешенное решение.',
  },
};

export const quizSuccessScreenDetails = {
  en: {
    title: 'Спасибо за Ваш отзыв!',
    desc: 'Благодарим за участие в нашем опросе. Ваш отзыв помогает нам становиться лучше. Пожалуйста, ознакомьтесь с нашими кейсами и отзывами клиентов.',
    buttonText: 'Наши кейсы и отзывы',
  },
  ru: {
    title: 'Спасибо за Ваш отзыв!',
    desc: 'Благодарим за участие в нашем опросе. Ваш отзыв помогает нам становиться лучше. Пожалуйста, ознакомьтесь с нашими кейсами и отзывами клиентов.',
    buttonText: 'Наши кейсы и отзывы',
  },
  de: {
    title: 'Спасибо за Ваш отзыв!',
    desc: 'Благодарим за участие в нашем опросе. Ваш отзыв помогает нам становиться лучше. Пожалуйста, ознакомьтесь с нашими кейсами и отзывами клиентов.',
    buttonText: 'Наши кейсы и отзывы',
  },
  tr: {
    title: 'Yorumunuz için teşekkür ederiz!',
    desc: 'Anketimize katıldığınız için teşekkür ederiz. Yorumunuz bize daha iyi olmamıza yardımcı oluyor. Lütfen vaka çalışmalarımızı ve müşteri yorumlarını inceleyin.',
    buttonText: 'Vaka çalışmalarımız ve yorumlarımız',
  },
};

export const quizDict = {
  en: {
    goToTest: 'Go to test',
    findOutTheResult: 'Find out the result',
    yourResult: 'Your result',
    nextQuestion: 'Next question',
  },
  ru: {
    goToTest: 'Перейти к тестированию',
    findOutTheResult: 'Узнать результат',
    yourResult: 'Ваш результат',
    nextQuestion: 'Следующий вопрос',
  },
  de: {
    goToTest: 'Gehen Sie zum Testen',
    findOutTheResult: 'Finden Sie das Ergebnis heraus',
    yourResult: 'Ihr Ergebnis',
    nextQuestion: 'Nächste Frage',
  },
  tr: {
    goToTest: 'Teste git',
    findOutTheResult: 'Sonucu öğren',
    yourResult: 'Sonuçlarınız',
    nextQuestion: 'Sonraki soru',
  },
  es: {
    goToTest: 'Ir a la prueba',
    findOutTheResult: 'Descubre el resultado',
    yourResult: 'Tu resultado',
    nextQuestion: 'Siguiente pregunta',
  },
};

export const quizCaribbeanDict = {
  en: {
    downloadGuide: 'Download the guide',
    getTheQuote: 'Get the quote',
    theLastStepLeft: 'Last step: tell us where to send it',
  },
  ru: {
    downloadGuide: 'Скачать руководство',
    getTheQuote: 'Получить расчет',
    theLastStepLeft: 'Последний шаг: скажите, куда отправить',
  },
};
